import { type IDropOptions, type IInboxTreeCombine, TreeRootInboxes } from 'entities/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

export const actionTeamsFavoriteDragDrop = async (
  options: IDropOptions<IInboxTreeCombine>,
  dropRoot: TreeRootInboxes,
  store: ConversationMenuStore
) => {
  const { dropTargetId, dragSource } = options
  const currentDropTargetId = dragSource?.parent
  const dropTarget = typeof dropTargetId === 'string' ? store.getItemTree(dropTargetId) : undefined
  const dragTarget =
    typeof currentDropTargetId === 'string' ? store.getItemTree(currentDropTargetId) : undefined
  const inbox = dragSource?.data
  const groupInbox = dragTarget?.data
  const realDropTargetId = dropTargetId || dropTarget?.parent

  const is_favorite = Boolean(
    dropRoot === TreeRootInboxes.FAVORITE && realDropTargetId === TreeRootInboxes.FAVORITE
  )

  if (inbox) {
    await store.handleUpdateTeamsFavorite({
      inbox: inbox,
      groupInbox: groupInbox,
      status: is_favorite,
    })
  }
}
